module.exports = __webpack_public_path__ + "img/public/AdminIcons/ownerPage.svg?aad3e6db";